import './App.css';
import { Home }  from './Pages/Home/home'
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";
import { CarsMenu } from '../src/Pages/carsMenu/carsMenu'


function App() {
  console.log(window.location.pathname)
  return (
    <div className="App bg-black">
      <Router>
        <Routes>
          <Route path="/VidaTrans" element={<Home />} />
          <Route path="/carsmenu" element={<CarsMenu />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;


